import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const grape = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return grape.get("/grapes?" + qstr);
  },
  find(id) {
    return grape.get("/grapes/" + id);
  },
  create(inputs) {
    return grape.post("/grapes", inputs);
  },
  update(id, inputs) {
    return grape.put("/grapes/" + id, inputs);
  },
  delete(id) {
    return grape.delete("/grapes/" + id);
  },
};
